export default {"src":"/_next/static/media/logo_black.064eec4f.svg","height":567,"width":3320,"blurWidth":0,"blurHeight":0};